import React from 'react';
import 'animate.css';
//icons

import { useAuth } from '../../context/AuthContext';
import { TiThMenu } from 'react-icons/ti';
import { CgMenuLeft } from 'react-icons/cg';
import { HiMiniSlash } from 'react-icons/hi2';
import styles from "./layout.module.css";
import { FaPowerOff } from 'react-icons/fa';
import Communications from '../../communications/communications';

//

export default function WindowLayout(props) {
    const { windowSize, isExandMenu, setIsExpandMenu,handleLogout,setMenuActual } = useAuth();
    const { title, children, icon, route,actions } = props;



    return (
        <>
            <div className='containerMainHome'>
                <div className={isExandMenu ? 'navbarWin2' : 'navbarWin'} >
                    <div className="navContainer">
                        <div className="navContainer2">
                            <div className='botonNav' onClick={() => setIsExpandMenu(!isExandMenu)} style={{display:windowSize.width<=768?"none":"flex"}}>
                                <CgMenuLeft></CgMenuLeft>
                            </div>
                            <div className='mainTitle' style={{cursor:"pointer"}} onClick={()=>setMenuActual("homeMenu")}>
                                <div className={styles.logo} >
                                <b style={{ marginRight: "10px",color:"#4293D7" }}>INVIRTIENDO </b> PLUS
                                </div>
                            </div>
                        </div>
                        <div className='btnLogout' onClick={handleLogout} >
                            <FaPowerOff />
                        </div>
                    </div>

                </div>
                <div className='contentContainer animate__animated animate__fadeIn' style={{
                    width: windowSize.width - (windowSize.width<=768?0:isExandMenu ? 250 : 60),
                    height: (windowSize.height - 50),
                    left: windowSize.width<=768?"0px": isExandMenu ? "250px" : "60px"
                }}>
                    <div className='titleModule'>
                        <div style={{display:"flex",alignItems:"center"}}>
                        {icon!=null?icon:""}&nbsp;{title.toString().toUpperCase()}
                        </div>
                        
                        <div className='titleRoute'>
                            {route != null && route.map((item, index) => {
                                if (index != (route.length - 1)) {
                                    return (
                                        (
                                            <>
                                                <div className='itemRoute' onClick={actions && props.actions[index]?actions[index]:()=>{}}>{item}</div>
                                                <div className='itemSlash'><HiMiniSlash /></div>
                                            </>
                                        )
                                    );
                                }
                                else {
                                    return (
                                        (
                                            <>
                                                <div className={'itemRouteActive'}>{item}</div>
                                            </>
                                        )
                                    );
                                }

                            })}
                        </div>
                    </div>
                    <div className='ContainerModule'>
                        {children}
                    </div>

                </div>
            </div>
            <Communications />
        </>
    )
}